import type { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { defaultLanguage, Language } from "../config/LanguageConfiguration";
import { NWONPage } from "../config/NWONPage";
import NWONTeamVideo from "../src/components/01-atoms/NWONTeamVideo/NWONTeamVideo";
import NWONTeamDetails from "../src/components/03-organisms/NWONTeamDetails/NWONTeamDetails";
import { NWONInitial } from "../src/components/NWONInitial/NWONInitial";
import { isLanguage } from "../src/helpers/general/isLanguage";
import { defaultNameSpaces } from "../src/i18n/i18n-namespaces";
import { GetStaticPropsDefault } from "../src/interfaces/GetStaticPropsDefault";

const Team: NextPage = () => {
  return (
    <NWONInitial pageInformationData={{ page: NWONPage.Team }}>
      <NWONTeamVideo />

      <NWONTeamDetails />
    </NWONInitial>
  );
};

export const getStaticProps: GetStaticPropsDefault = async (context) => {
  const locale = isLanguage(context.locale) ? context.locale : defaultLanguage;

  return {
    props: {
      ...(await serverSideTranslations(
        locale,
        defaultNameSpaces.concat([
          "common",
          "companyFacts",
          "pages",
          "subService",
          "timeline",
        ]),
        null,
        [Language.German, Language.English]
      )),
    },
  };
};

export default Team;
